import { createSlice } from "@reduxjs/toolkit"

const INITIAL_STATE = {
    topNavSearchValue: '',
}

export const topNavSearchSlice = createSlice({
    name: "topNavSearchSlice",
    initialState: INITIAL_STATE,
    reducers: {
        setTopNavSearchValue: (state, action) => {
            state.topNavSearchValue = action.payload
        },
    }
})


export const { setTopNavSearchValue } = topNavSearchSlice.actions
export default topNavSearchSlice.reducer